import {Dispatch} from "react";
import {CourseRegistrationData, LoginData, RegisterData, StudentActionType} from "../interfaces/interfaces";
import axios from "axios";
import {StudentType} from "../interfaces/actionTypes";
import Swal from "sweetalert2";

export function studentLogin(loginData: LoginData) {
  return async function (dispatch: Dispatch<StudentActionType>) {
    try {
      loading();
      const res = await axios.post("/user/student/login", loginData);
      console.log(res.data);
      if (res.data.success === false) {
        await Swal.fire({
          icon: "error",
          text: res.data.message
        })
        return dispatch({
          type: StudentType.AUTH_ERROR,
          payload: res.data
        })
      }
      if (res.data.success === true) {
        return dispatch({
          type: StudentType.LOGIN,
          payload: res.data
        });
      }
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function studentRegister(registerData: RegisterData) {
  return async function (dispatch: Dispatch<StudentActionType>) {
    try {
      loading();

      const res = await axios.post("/user/student/register", registerData);
      console.log(res.data);
      if (res.data.success === true) {
        dispatch({
          type: StudentType.REGISTER,
          payload: res.data
        });
      }
      if (res.data.success === false) {
        await Swal.fire({
          icon: "error",
          text: res.data.message
        })
        return dispatch({
          type: StudentType.AUTH_ERROR,
          payload: res.data
        })
      }
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      return dispatch({
        type: StudentType.AUTH_ERROR,
        payload: err
      })
    }
  }
}

export function getCourses(studentToken: string) {
  return async function (dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${studentToken}`
      }
    }
    try {
      loading();
      const res = await axios.get("/user/student/courses", config)
      //console.log(res.data);
      if (res.data.success === true) {
        return dispatch({
          type: StudentType.GET_COURSES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
    } catch (e) {
      console.log(e);
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: e
      })
    }
  }
}

export function courseRegister(courseData: CourseRegistrationData, studentToken: string) {
  return async function (dispatch: Dispatch<StudentActionType>) {
    try {
      loading();
      const config = {
        headers: {
          "Authorization": `Bearer ${studentToken}`
        }
      }
      const res = await axios.post("/user/student/courses", courseData, config);
      console.log(res.data)
      if (res.data.success === true) {
        await Swal.fire({
          icon: 'success',
          text: res.data.message
        })
        return dispatch({
          type: StudentType.REGISTER_COURSES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
    } catch (err) {
      console.log(err)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getStudentRegisteredCourses(token: string) {
  return async function (dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      loading();

      const res = await axios.get("/user/student/registered-courses", config);
      console.log(res.data)
      if (res.data.success === true) {
        return dispatch({
          type: StudentType.REGISTERED_COURSES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function getStudentLessons(token: string) {
  return async function(dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      loading();
      const res = await axios.get("/user/student/lessons", config);
      console.log(res.data);
      if (res.data.success) {
        return dispatch({
          type: StudentType.GET_LESSONS,
          payload: res.data
        });
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function getStudentNotes(token: string) {
  return async function(dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      loading();
      
      const res = await axios.get("/user/student/notes", config);
      console.log(res.data);
      if (res.data.success) {
        return dispatch({
          type: StudentType.GET_NOTES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function getStudentAssignments(token: string) {
  return async function(dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      loading();

      const res = await axios.get("/user/student/assignments", config);
      console.log(res.data);
      if (res.data.success) {
        return dispatch({
          type: StudentType.GET_ASSIGNMENTS,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function getStudentSubmittedAssignments(token: string) {
  return async function(dispatch: Dispatch<StudentActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      const res = await axios.get("/user/student/submitted-assignments", config);
      console.log(res.data);
      if (res.data.success) {
        return dispatch({
          type: StudentType.GET_SUBMITTED_ASSIGNMENTS,
          payload: res.data.submitted_assignments
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: StudentType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function studentLogout() {
  localStorage.removeItem("vidcom");
  return {
    type: StudentType.LOGOUT,
  };
}

export function loading() {
  return {
    type: StudentType.LOADING,
  };
}